<!--
 * @Author: Gaho
 * @Date: 2024-03-05 14:50:20
 * @LastEditors: Gaho
 * @LastEditTime: 2024-08-21 14:44:52
 * @Description: circle下注历史
-->
<template>
    <div class="circle-bet-history">
        <div 
            v-for="(item, index) in Object.entries(formatBetData)" 
            :key="item[0]" 
            class="circle-bet-history-item"
            :class="[
                formatClass(item[0]),
            ]"
            v-show="item[1] > 0"
            :style="index === winSector && betArray?.length ? `background: ${shineColor};` : ''"
        >
            {{ item[1] }}
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { accAdd } from "@/pages/casino/plinkoGame/js/module.js";
import { circleSectors } from '../../data';
export default defineComponent({
    name: 'circleBetHistory',
    props: {
        betArray: {
            type: Object,
            default: () => ({})
        },
        circleResult: {
            type: Object,
            default: () => ({})
        },
        borderColor: {
            type: String,
            default: '',
        },
        lastResult: {
            type: Number,
            default: 0,
        }
    },
    watch: {
        betArray: {
            handler(newVal){
                if (newVal?.length){
                    this.formatBetData = {
                        "gray": 0,
                        "red": 0,
                        "green": 0,
                        "yellow": 0
                    };
                    newVal.forEach((item) => {
                        if (this.formatBetData[item.sector]){
                            this.formatBetData[item.sector] = getFixed(accAdd(this.formatBetData[item.sector], item.amount));
                        } else {
                            this.formatBetData[item.sector] = getFixed(item.amount);
                        }
                    })
                } else {
                    this.formatBetData = {
                        "gray": 0,
                        "red": 0,
                        "green": 0,
                        "yellow": 0
                    };
                    this.shineColor = '';
                    this.winSector = -1;
                }
            },
            deep: true,
            immediate: true
        },
        borderColor: {
            async handler(newColor){
                if (newColor){
                    this.shineColor = newColor;
                    // 因为过渡动画无法直接设置执行多次，所以通过延时切换的方式实现闪烁两次的效果
                    setTimeout(() => {
                        this.shineColor = 'rgb(27, 34, 51)';
                        setTimeout(() => {
                            this.shineColor = newColor;
                        }, 500)
                    }, 500)
                }
            },
            immediate: true,
            deep: true
        },
        shineColor: {
            handler(newVal, oldVal){
                if (newVal && newVal !== oldVal && newVal !== 'rgb(27, 34, 51)'){
                    this.winSector = circleSectors[this.lastResult] - 1;
                }
            }
        }
    },
    data(){
        return {
            formatBetData: {
                "gray": 0,
                "red": 0,
                "green": 0,
                "yellow": 0
            },
            shineColor: '',
            winSector: -1
        }
    },
    methods: {
        /**
         * 根据下注类型设置对应的样式
         * @param sector { string } 下注类型
         */
        formatClass(sector: string){
            let resultClass = '';
            switch(sector){
                case 'gray':
                    resultClass = 'circle-bet-history-itemx2';
                break;
                case 'red':
                    resultClass = 'circle-bet-history-itemx3';
                break;
                case 'green':
                    resultClass = 'circle-bet-history-itemx5';
                break;
                case 'yellow':
                    resultClass = 'circle-bet-history-itemx53';
                break;
                default: 
            }
            return resultClass;
        }
    }
});
</script>
<style lang="scss" scoped>
.circle-bet-history {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 20px;
    bottom: 0;
    z-index: 4;
    @media (max-width: 1100px) {
        align-items: flex-start;
        left: auto;
        right: 0;
    }
    .circle-bet-history-item {
        display: block;
        position: relative;
        width: 30px;
        height: 20px;
        user-select: none;
        font-size: 11px;
        font-weight: 600;
        align-items: center;
        border-radius: 2px;
        display: flex;
        justify-content: center;
        letter-spacing: -0.07em;
        line-height: 12px;
        margin-bottom: 4px;
        text-shadow: 0 1px 2px #dc6108;
        transition: background .5s;
        will-change: transform;
    }
    .circle-bet-history-itemx2 {
        background-color: #5b6773;

    }
    .circle-bet-history-itemx3 {
        background-color: #ed1d49;

    }
    .circle-bet-history-itemx5 {
        background-color: #1bb83d;

    }
    .circle-bet-history-itemx53 {
        background-color: #ffb636;

    }
}
.win {
    animation: shine .5s;
}
@keyframes shine {
    0% {
        opacity: 1;
    }
    50% {
        opacity: .5;
    }
    100% {
        opacity: 1;
    }
}
</style>